<template>
    <div class="approval container-flex">
        <div class="panel panel-primary col-xs-8">
            <div class="panel-heading">
                <h4 class="panel-title">Approval Queue</h4>
            </div>
            <div class="panel-body">
                <loader class="panel-loader" v-if="!isDataLoaded"></loader>
                <div class="error-container alert alert-danger" v-if="isDataLoaded && hasError">
                    {{error}}
                </div>
                <div class="customer-search-results" v-if="hasResults">
                    <sortable-table :data="results" :columns="columns" :action="selectAction" v-on:action:select="select" />
                </div>
                <div class="customer-search-no-results" v-if="!hasResults">
                    0 requests found
                </div>
            </div>
        </div>

        <div class="panel panel-primary col-xs-4" v-if="hasSelected">
            <div class="panel-heading">
                <h4 class="panel-title">Approval</h4>
            </div>
            <div class="panel-body">
                <h3>{{selectedData.status}} Request</h3>
                <h4>{{selectedData.requestBy}} to {{selectedData.assignedTo}}:</h4>
                <p>{{selectedData.title}}</p>
                <h3>Notes</h3>
                <div class="note" v-for="note in selectedData.notes">
                    <div><span class="author">{{note.by}}</span> on <span class="date">{{note.date}}</span></div>
                    <pre>{{note.body}}</pre>
                </div>
                <div class="note">
                    <div><span class="author">Add a Comment</span></div>
                    <textarea class="pre col-xs-12" :class="{'alert-danger': commentLength > maxCommentLength, 'alert-warning': commentLength < minCommentLength}" v-model="comment"></textarea>
                    <div class="character-counter" :class="{'text-danger': commentLength > maxCommentLength}">
                        <template v-if="commentLength < minCommentLength">{{minCommentLength-commentLength}} character{{minCommentLength-commentLength != 1 ? 's' : ''}} too short</template>
                        <template v-else-if="commentLength <= maxCommentLength">{{maxCommentLength-commentLength}} character{{maxCommentLength-commentLength != 1 ? 's' : ''}} remaining</template>
                        <template v-else="">{{commentLength-maxCommentLength}} character{{commentLength-maxCommentLength != 1 ? 's' : ''}} too long</template>
                    </div>
                </div>
                <div>
                    <button class="search-action btn btn-danger col-xs-3 pull-right" :disabled="commentLength < minCommentLength || commentLength > maxCommentLength" v-on:click="reject()">Reject</button>
                    <button class="search-action btn btn-primary col-xs-3 pull-right" :disabled="commentLength < minCommentLength || commentLength > maxCommentLength" v-on:click="approve()">Approve</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import axios from 'axios'
    import querystring from 'querystring'
    import Loader from '@/components/Loader'
    import SortableTable from '@/components/SortableTable'

    export default {
        props: [
            'contentSource',
            'approvalPath',
            'rejectPath'
        ],
        name: 'ApprovalQueue',
        components: {
            SortableTable,
            Loader
        },
        data () {
            return {
                minCommentLength: 10,
                maxCommentLength: 500,
                content: false,
                options: null,
                displayMode: false,
                results: null,
                columns: null,
                error: null,
                selectAction: 'action:select',
                selected: null,
                selectedData: null,
                comment: ''
            }
        },
        computed: {
            isDataLoaded () {
                return this.content || false
            },
            hasResults () {
                return Array.isArray(this.results) && this.results.length
            },
            hasError () {
                return this.error !== undefined && this.error !== null
            },
            hasSelected () {
                return this.selected !== undefined && this.selected !== null
            },
            commentLength () {
                return this.comment.length
            }
        },
        methods: {
            select (event) {
                const self = this
                this.selected = event
                this.selectedData = self.results.filter(function (element) {
                    return parseInt(element.id) === parseInt(event)
                })[0]
                this.comment = ''
            },
            remove (id) {
                const self = this

                this.results = self.results.filter(function (element) {
                    return parseInt(element.id) !== parseInt(id)
                })

                this.selected = null
                this.selectedData = {}
                this.comment = ''
            },
            getData () {
                this.content = false
                let self = this
                return axios.post(this.contentSource, querystring.stringify({}), {headers: {'Content-Type': 'application/x-www-form-urlencoded'}})
                    .then(function (response) {
                        if (!response.data.result) {
                            response.data.error = response.data.message || 'An unknown error has occurred'
                        }
                        self.setData(self, response.data)
                    })
                    .catch((error) => {
                        if (error instanceof Error) {
                            self.setData({error: error.message || 'An unknown error has occurred'})
                        }
                    })
            },
            setData (self, data) {
                self.content = true
                self.columns = data.columns || self.columns || {}
                self.results = data.results || self.results || null
                self.error = data.error || null
            },
            trimResults (event) {
                this.results = this.results.filter(function (element) {
                    return event.indexOf(element.id) < 0
                })
            },
            approve () {
                this.resolve(this.approvalPath)
            },
            reject () {
                this.resolve(this.rejectPath)
            },
            resolve (path) {
                let self = this
                let data = {
                    id: this.selected,
                    comment: this.comment
                }

                if (path !== undefined) {
                    return axios.post(path, querystring.stringify(data), {headers: {'Content-Type': 'application/x-www-form-urlencoded'}})
                        .then(function (response) {
                            if (!response.data.success) {
                                response.data.error = response.data.message || 'An unknown error has occurred'
                            } else {
                                self.remove(self.selected)
                            }
                        })
                        .catch((error) => {
                            if (error instanceof Error) {
                                self.setData(self, {error: error.message || 'An unknown error has occurred'})
                            }
                        })
                } else {
                    self.remove(self.selected)
                }
            }
        },
        created () {
            if (this.contentSource !== undefined && this.contentSource !== null) {
                this.getData()
            }
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>

</style>



// WEBPACK FOOTER //
// ApprovalQueue.vue?78a5360c